class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    if(!event.target.classList.contains("search__button") || !event.target.closest(".search__button")){
      event.preventDefault();
    }

    const isOpen = event.target.closest('details').hasAttribute('open');

    // Tapping inside the search field of an already open modal should only move the caret,
    // otherwise the modal closes and the next tap re-opens it with the whole value selected.
    if (isOpen && event.target.closest('.search-modal__form-wrap')) return;

    isOpen ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
    // trapFocus() selects the whole value, so the next keystroke would wipe what is already
    // in the field. Remember where the shopper tapped and put the caret back there.
    const caretPosition = (event.target === input ? input.selectionStart : null) ?? input?.value.length;

    trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), input);

    if (input && input.value && typeof input.setSelectionRange === 'function') {
      input.setSelectionRange(caretPosition, caretPosition);
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
